export default "__VITE_ASSET__CuKEfKWh__"